(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mrka-creator-bento"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    function init(root) {
      root.querySelectorAll('.mrka-bento').forEach(section => {
        if (initialized.has(section)) return;
        initialized.add(section);
        const cards = [...section.querySelectorAll('[data-mrka-card]')];
        const silence = card => {
          const video = card.querySelector('video');
          const button = card.querySelector('[data-mrka-sound]');
          video.muted = true;
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', 'Ativar som');
        };
        cards.forEach(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('[data-mrka-sound]');
          video.playsInline = true;
          button.addEventListener('click', () => {
            if (!video.muted) {
              silence(card);
              return;
            }
            cards.forEach(other => {
              if (other !== card) {
                silence(other);
                other.querySelector('video').pause();
                other.classList.remove('is-playing');
              }
            });
            video.muted = false;
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', 'Desativar som');
            video.play().then(() => card.classList.add('is-playing')).catch(() => silence(card));
          });
          if (window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
            card.addEventListener('pointerenter', () => {
              const preview = card.querySelector('video');
              preview.play().then(() => {
                if (card.matches(':hover') || !preview.muted) card.classList.add('is-playing');
                else preview.pause();
              }).catch(() => {});
            });
            card.addEventListener('pointerleave', () => {
              if (!video.muted) return;
              video.pause();
              card.classList.remove('is-playing');
            });
          }
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
